// extracted by mini-css-extract-plugin
export var skipAnimation = "_2f-0";